import request from '@/utils/request'; // 获取楼栋单元列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/house/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/house/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/house/info',
    method: 'post',
    data: data
  });
}
export function fetchHouseDetail(data) {
  return request({
    url: '/pmsservice/api/houseStatus/get',
    method: 'post',
    data: data
  });
} // 获取楼层

export function fetchFloor(data) {
  return request({
    url: '/pmsservice/api/house/dropDownList',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/house/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/house/update',
    method: 'post',
    data: data
  });
} //导出模板

export function exportList(data) {
  return request({
    url: '/pmsservice/api/house/exportList',
    method: 'post',
    data: data
  });
} // 导入模板

export function importBatch(data) {
  return request({
    url: '/pmsservice/api/house/importBatch',
    method: 'post',
    data: data
  });
} // 人房关系导出

export function relationExportList(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/findHousePersonList',
    method: 'post',
    data: data
  });
} // 人房关系导出模板

export function relationExport(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/exportList',
    method: 'post',
    data: data
  });
} // 人房关系导入

export function relationimportBatch(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/importBatch',
    method: 'post',
    data: data
  });
}
export function renting(data) {
  return request({
    url: '/pmsservice/api/customerOa/list',
    method: 'post',
    data: data
  });
}
export function unRent(data) {
  return request({
    url: '/pmsservice/api/customerOa/unRent',
    method: 'post',
    data: data
  });
}
export function unRentList(data) {
  return request({
    url: '/pmsservice/api/customerOa/unRentList',
    method: 'post',
    data: data
  });
}